import React from "react";
import "./financeOptions.css";

import {
  Row,
  Col,
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container
} from "reactstrap";

// export default FinanceOptions;
const FinanceOptions = props => {
  return (
    <div className=" left-align mt-lg-5 pt-lg-5">
      <Container>
        <Col lg={{ offset: 1 }}>
          <Row className="left-align ">
            <Col xs={{ size: 11 }} className="flex-headline ">
              <h1>Flexible Finance Options</h1>
            </Col>
          </Row>
          <Row>
            <Col lg={{ size: 11 }} className="mt-4 ">
              <p className="finance-divide">
                Dedicated to making our programs more accessible, we offer
                competitive financing options from Income Share Agreements to
                select scholarships and discounts.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center justify-content-md-start">
            <Col lg={{ size: 11 }} className="mt-4">
              <h4 className="pb-3">Income Share Agreement</h4>
              <p className="">
                Pay back tutition in just a few years after you get a job.
              </p>
              <p className="">
                Not available to students outside of the United States.
              </p>{" "}
              <h4>$0</h4>
              <p className="finance-divide">Upfront Cost</p>
            </Col>
          </Row>
          <Row className="justify-content-center justify-content-md-start">
            <Col lg={{ size: 11 }} className="mt-4">
              <h4 className="pb-3">Loans</h4>
              <p className="finance-divide ">
              Apply for a load through one of our lending partners. Must be a U.S. Citizen or resident. 
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center justify-content-md-start">
            <Col lg={{ size: 11 }} className="mt-4">
              <h4>Full Tuition (Enroll in Advance Discount)</h4>{" "}
              <p className=" ">
                Our tuition is competitive compared to traditional institutions and
                covers your curriculum, resources and course experience.
              </p>{" "}
              <Row className="justify-content-center justify-content-md-start">
                <Col lg={{ size: 3 }} className="mt-4 ">
                  <h4>{props.tuition}</h4>
                  <p>Full Tuition</p>
                </Col>
                <Col lg={{ size: 4 }} className="mt-4">
                  <h4>10% Off</h4>
                  <p  >Early Enrollment Incentive</p>
                </Col>
              </Row>
            </Col>
          </Row>
          
          
          <Row className="justify-content-center justify-content-md-start">
            <Col lg={{ size: 11 }} className="mt-4 ">
              <h4 className="top-line pb-3">Stay Relevant Scholarship</h4>{" "}
              <p className="finance-divide ">
                Lighthouse occasionally offers a variety of scholarships to
                select students. We want to stay aligned with the mission of
                making education accessible to more students. Speak to our
                advisors to discuss the scholarships we have available.
              </p>{" "}
            </Col>
          </Row>
        </Col>
      </Container>
    </div>
  );
};

export default FinanceOptions;
